export const config = {
    authority: 'https://id-test.locate2u.com/',
    redirect_uri: 'https://dev2-as-app-portal.locate2u.com/callback',
    post_logout_redirect_uri: 'https://dev2-as-app-portal.locate2u.com/login',
    silent_redirect_uri: 'https://dev2-as-app-portal.locate2u.com/static/silent-renew.html',
    billing_redirect_url: 'https://dev2-as-app-portal.locate2u.com/dashboard'
};
